import angular from 'angular';
import EquipmentInfoService from './EquipmentInfoService';
import DashboardInfoService from './DashboardInfoService';
import EventInfoService from './EventInfoService';
import RcuInfoService from './RcuInfoService';
import UserInfoService from './UserInfoService';


export default angular
  .module('petroCloud.infoServices', ['ngSails'])
  .service('UserInfoService', UserInfoService)
  .service('EquipmentInfoService', EquipmentInfoService)
  .service('DashboardInfoService', DashboardInfoService)
  .service('EventInfoService', EventInfoService)
  .service('RcuInfoService', RcuInfoService)
  .name;
